import { render, staticRenderFns } from "./ControlsButton.vue?vue&type=template&id=1ae39506&scoped=true&"
import script from "./ControlsButton.vue?vue&type=script&lang=js&"
export * from "./ControlsButton.vue?vue&type=script&lang=js&"
import style0 from "./ControlsButton.vue?vue&type=style&index=0&id=1ae39506&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae39506",
  null
  
)

export default component.exports